import React from "react";
import { sanitizeInput } from "../../../../utils/securityUtils";

const GuestDataForm = ({forms,updateFormsData,errors,title,label}) => {
  const nativeSelectClass =
    "bg-white appearance-none leading-normal min-h-[42px] xl:min-h-[2.85vw] pr-10";
  const nativeSelectStyle = {
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M5 7.5L10 12.5L15 7.5' stroke='%23002C5F' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 0.75rem center",
    backgroundSize: "0.95rem 0.95rem",
  };

  // Handle input with sanitization
  const handleInputChange = (index, field, value, type = "text") => {
    const sanitized = sanitizeInput(value, type);
    updateFormsData(index, field, sanitized);
  };

  return (
    <div>
      {forms?.map((guest, index) => (
        <div key={index} className="pb-[2vw] mb-[1vw]">
          <h3 className="mt-[0.5vw] rounded-md mb-[1vw] p-[0.5vw] shadow-md shadow-primary border-b-[0.2vw]  border-primary text-primary text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw] font-redhatMedium">
            {label} {index + 1}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-12 xl:grid-cols-12 gap-4 mb-4">
            <div className="col-span-5 md:col-span-2">
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                Title*
              </label>
              <select
                value={guest.title}
                onChange={(e) =>
                  updateFormsData(index, "title", e.target.value)
                }
                className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${nativeSelectClass}`}
                style={nativeSelectStyle}
              >
                <option value="">Select</option>
                {title &&
                  title?.map((el, ind) => (
                    <option key={ind} value={`${el.id}-${el.name}`}>
                      {el.name}
                    </option>
                  ))}
              </select>
              {errors[index]?.title && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].title}
                </p>
              )}
            </div>
            <div className="col-span-5">
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                First Name*
              </label>
              <input
                value={guest.first_name}
                onChange={(e) =>
                  handleInputChange(index, "first_name", e.target.value, "name")
                }
                type="text"
                placeholder="Enter First Name"
                maxLength={50}
                className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
              />
              {errors[index]?.first_name && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].first_name}
                </p>
              )}
            </div>
            <div className="col-span-5">
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                Last Name*
              </label>
              <input
                value={guest.last_name}
                onChange={(e) =>
                  handleInputChange(index, "last_name", e.target.value, "name")
                }
                type="text"
                placeholder="Enter Last Name"
                maxLength={50}
                className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
              />
              {errors[index]?.last_name && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].last_name}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                Travel Class*
              </label>
              <select
                value={guest.travelClass}
                onChange={(e) =>
                  updateFormsData(index, "travelClass", e.target.value)
                }
                className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] focus:outline-none focus:ring-0 ${nativeSelectClass}`}
                style={nativeSelectStyle}
              >
                <option value="">Select</option>
                <option value="First">First</option>
                <option value="Economy">Economy</option>
                <option value="Business">Business</option>
              </select>
              {errors[index]?.travelClass && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].travelClass}
                </p>
              )}
            </div>
            <div>
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                Age*
              </label>
              <input
                value={guest.age}
                onChange={(e) => handleInputChange(index, "age", e.target.value, "numeric")}
                type="text"
                placeholder="Enter Age"
                maxLength={3}
                className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
              />
              {errors[index]?.age && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].age}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                Passport/Govt ID*
              </label>
              <input
                value={guest.passport}
                onChange={(e) =>
                  handleInputChange(index, "passport", e.target.value, "passport")
                }
                type="text"
                placeholder="Enter Passport/Govt ID"
                maxLength={12}
                className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
              />
              {errors[index]?.passport && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].passport}
                </p>
              )}
            </div>
            <div>
              <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                Gender*
              </label>
              <select
                value={guest.gender}
                onChange={(e) =>
                  updateFormsData(index, "gender", e.target.value)
                }
                className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] focus:outline-none focus:ring-0 ${nativeSelectClass}`}
                style={nativeSelectStyle}
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              {errors[index]?.gender && (
                <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                  {errors[index].gender}
                </p>
              )}
            </div>
          </div>

          <div>
            <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
              PNR No*
            </label>
            <input
              value={guest.pnr}
              onChange={(e) => handleInputChange(index, "pnr", e.target.value, "pnr")}
              type="text"
              placeholder="Enter PNR No"
              maxLength={10}
              className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
            />
            {errors[index]?.pnr && (
              <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                {errors[index].pnr}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GuestDataForm;
